import getApiInstance from 'data/common/ApiCallGenerique';
import Translator from 'translator';
import { Logger, Toastr } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getUsers() {
    return dispatch => {
        return apiCaller
            .call(api.getAllUsers())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__SET_USERS',
                        users: data.users
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEUsers - ', error);
                throw error;
            });
    };
}
function getUserDetails(userId) {
    return dispatch => {
        return apiCaller
            .call(api.getUserDetails(userId))
            .then(({ data }) => {
                if (data.userDetails)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_USER',
                        userDetails: data.userDetails,
                        userId: userId
                    });

                if (data.userSDM17SPG)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_UPDATE_SDM17SPGS',
                        SDM17SPGs: data.userSDM17SPG
                    });

                if (data.userSDM18HCL)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_UPDATE_SDM18HCLS',
                        SDM18HCLs: data.userSDM18HCL
                    });

                if (data.userSDM18MVR)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_UPDATE_SDM18MVRS',
                        SDM18MVRs: data.userSDM18MVR
                    });
                if (data.userRemote)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_UPDATE_REMOTES',
                        Remotes: data.userRemote
                    });
                if (data.userSDM20LHT)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_UPDATE_SDM20LHTS',
                        SDM20LHTs: data.userSDM20LHT
                    });
                if (data.userSecurity)
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_UPDATE_SECURITIES',
                        Securities: data.userSecurity
                    });

                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEUserDetails - ', error);
                throw error;
            });
    };
}
function updateUserDetails(userId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateUserDetails(userId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__USER_UPDATE_DETAILS',
                        userId: data.user._id,
                        userDetails: data.user
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEUserDetails - ', error);
                throw error;
            });
    };
}
function addUser(userForm) {
    return dispatch => {
        return apiCaller
            .call(api.addUser(userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__ADD_USER',
                        userId: data.user._id,
                        userDetails: data.user
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: setMyFHEAddUser - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.${data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message}`,
                                'api.message.default'
                            ),
                            Translator.translate('api.message.intermediate_error')
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEAddUser - ', error);
                throw error;
            });
    };
}
function resetPassword(userId) {
    return () => {
        return apiCaller
            .call(api.resetPassword(userId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEResetPassword - ', error);
                throw error;
            });
    };
}

export { getUsers, getUserDetails, updateUserDetails, addUser, resetPassword };



// WEBPACK FOOTER //
// ./environments/myfhe/data/Users/actions.js